import styled from "styled-components";

export const Header = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 860px;
  display: flex;
`;
export const HeaderTitle = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  color: #808080;
  font-size: 12px;
  font-weight: 600;
  text-align: ${({ textAlign }) => textAlign && textAlign};
`;
